import {
  GetCategoryLinkByPathQuery,
  GetCategoryLinkByPathQueryVariables,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { GET_CATEGORY_LINK_BY_PATH } from '@dustin-web/microsite-data/src/graphql/product/get-category-link-by-path'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks'

export const useCategoryLinkByPath = (categoryPath: string) => {
  return useGraphql<GetCategoryLinkByPathQuery, GetCategoryLinkByPathQueryVariables>(
    GET_CATEGORY_LINK_BY_PATH,
    {
      variables: {
        categoryPath: categoryPath,
        isSoftCategory: false,
      },
    }
  )
}
